import { withTranslation } from "react-i18next";
import { GetAllActiveUsers, GetAllUserTypes } from "../../Apis/userCreationApi";
import { useEffect, useState } from "react";
import CustomDataTable from "../../Common/ReportTable/ReportTable";
import { formatDateTime } from "../../Common/helper/helpar";
import { TableLoader } from "../../Common/ShimmerLoader";
import isGHMC from "../../Common/helper/helpar";
import { ExportActiveUsersExcel } from "./exportActiveUsers";

const ActiveUsers = ({ t }) => {
    const [activeUsers, setActiveUsers] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const [userType, setUserType] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState("");
    const isProd = isGHMC();


    const fetchData = async (userTypeId) => {
        setDataLoading(true);
        try {
            const data = await GetAllActiveUsers(userTypeId);
            setActiveUsers(data);
            setDataLoading(false);
        } catch (error) {
            console.error("Error fetching countries:", error);
            setDataLoading(false);
        }
    };

    const getAllUserTypes = async () => {
        try {
            const userTypesDropdown = await GetAllUserTypes();
            const filteredUserTypes = userTypesDropdown.filter(
                (userType) => userType.userTypeName !== null
            );
            setUserType(filteredUserTypes);
        } catch (error) {
            console.error("Error fetching roles permissions:", error);
        }
    };

    const handleClickUserType = () => {
        fetchData(selectedUserType)
    }
    useEffect(() => {
        getAllUserTypes();
        fetchData(selectedUserType);
    }, []);

    const ActiveUsersColumns = [
        {
            name: "S.No",
            selector: (row) => row["slno"],
            format: (row, rowIndex) => rowIndex + 1,
            width: '90px',
        },
        {
            name: "User ID",
            selector: (row) => row["userId"],
            width: '110px',
        },
        {
            name: "User Name",
            selector: (row) => row["userName"],
        },
        {
            name: "User Type",
            selector: (row) => row["userTypeName"],
        },
        {
            name: "IP Address",
            selector: (row) => row["ipAddress"],
        },
        {
            name: "Session Login Time",
            selector: (row) => row["createdAt"],
            cell: (row) => row["createdAt"] && formatDateTime(row["createdAt"])
        },
        {
            name: "Session Logout Time",
            selector: (row) => row["expiresAt"],
            cell: (row) => row["expiresAt"] && formatDateTime(row["expiresAt"])
        },
    ];
    return (
        <div className="content text-start">
            <div className="page-content mt-3">
              <div className="top-header page-title">
                <span>{t("Active Users")}</span>
              </div>
                {/* <div className="d-flex justify-content-between">
                    <div className="">
                        <h4 class="text-start mb-3">{t("Active Users")}</h4>
                    </div>

                </div> */}
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <div className="mb-1 me-3">
                            <label className="form-label">User Type</label>
                            <select
                                className="form-select bg-white"
                                name="userTypeId"
                                value={selectedUserType}
                                onChange={(e) => setSelectedUserType(e.target.value)}
                            >
                                <option value="">All</option>
                                {userType.map((userTypes) => (
                                    <option key={userTypes.userTypeId} value={userTypes.userTypeId}>
                                        {userTypes.userTypeName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-2 mt-2">
                            <button
                                type="submit"
                                className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                onClick={handleClickUserType}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                    <div>
                    <ExportActiveUsersExcel filteredData={activeUsers}/>
                    </div>
                </div>
                <div className="card mt-3">
                    <div className="card-body p-3">
                        {dataLoading ? <TableLoader height={500} /> : <CustomDataTable
                            data={activeUsers}
                            columns={ActiveUsersColumns}
                            showTotal={false}
                        />}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default withTranslation()(ActiveUsers);